export function wizardStepKey(step: { code: string | number; index?: number }, suffix = '') {
  const base = step.index === undefined ? String(step.code) : `${step.code}-${step.index}`;
  return suffix ? `${base}-${suffix}` : base;
}
